function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "151px",
    height: "151px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.877
    },
    fill: "#fefffe",
    d: "M 14.5,-0.5 C 20.5,-0.5 26.5,-0.5 32.5,-0.5C 32.5,49.8333 32.5,100.167 32.5,150.5C 26.5,150.5 20.5,150.5 14.5,150.5C 14.5,100.167 14.5,49.8333 14.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.88
    },
    fill: "#fefffe",
    d: "M 36.5,-0.5 C 42.5,-0.5 48.5,-0.5 54.5,-0.5C 54.5,24.1667 54.5,48.8333 54.5,73.5C 58.5,73.5 62.5,73.5 66.5,73.5C 66.3118,71.8967 66.8118,70.5634 68,69.5C 71.3137,73.6481 74.8137,77.6481 78.5,81.5C 74.8137,85.3519 71.3137,89.3519 68,93.5C 66.8118,92.4366 66.3118,91.1033 66.5,89.5C 56.6171,90.744 46.7837,90.744 37,89.5C 36.5,59.5019 36.3334,29.5019 36.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.879
    },
    fill: "#fefffe",
    d: "M 94.5,-0.5 C 100.5,-0.5 106.5,-0.5 112.5,-0.5C 112.5,17.5 112.5,35.5 112.5,53.5C 106.5,53.5 100.5,53.5 94.5,53.5C 94.5,35.5 94.5,17.5 94.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.877
    },
    fill: "#fefffe",
    d: "M 116.5,-0.5 C 122.5,-0.5 128.5,-0.5 134.5,-0.5C 134.5,49.8333 134.5,100.167 134.5,150.5C 128.833,150.5 123.167,150.5 117.5,150.5C 116.505,100.238 116.172,49.9051 116.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.882
    },
    fill: "#fefffe",
    d: "M 112.5,150.5 C 106.5,150.5 100.5,150.5 94.5,150.5C 94.5,125.833 94.5,101.167 94.5,76.5C 90.5,76.5 86.5,76.5 82.5,76.5C 82.719,77.675 82.3857,78.675 81.5,79.5C 77.9669,75.803 74.6335,71.9696 71.5,68C 74.6626,64.005 77.9959,60.1717 81.5,56.5C 82.3857,57.325 82.719,58.325 82.5,59.5C 92.5,59.5 102.5,59.5 112.5,59.5C 112.5,89.8333 112.5,120.167 112.5,150.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.914
    },
    fill: "#fefffe",
    d: "M 54.5,150.5 C 48.8333,150.5 43.1667,150.5 37.5,150.5C 37.5,132.167 37.5,113.833 37.5,95.5C 43.1667,95.5 48.8333,95.5 54.5,95.5C 54.5,113.833 54.5,132.167 54.5,150.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.348e8ba73a1db4ad744d11cc753dd6ee.svg";
export { ForwardRef as ReactComponent };